export const ADD_DISH = '@@reservble/app/ADD_DISH';
export const REMOVE_DISH = '@@reservble/app/REMOVE_DISH';
export const CLEAR_ORDER = '@@reservble/app/CLEAR_ORDER';
export const REPLACE_DISH = '@@reservble/app/REPLACE_DISH';
